import axios from 'axios';
import {authService} from "../services/authenticationServiceInstance";
import StorageService from "../services/storageService";
import jwtDecode from 'jwt-decode';

let storageService = new StorageService();
// Obtain the fresh token each time the function is called
function getAccessToken(){
    return  authService.getToken();
}

// Use interceptor to inject the token to requests
axios.interceptors.request.use(request => {
    
    if(request.url.indexOf(process.env.VUE_APP_ROOT_API)>=0){
        let authMode = storageService.get("auth_mode");
        if(authMode == 'cw'){
            getAccessToken().then(token=>{
                let decodedToken = jwtDecode(token);
                if(Date.now() >= decodedToken.exp *1000)
                {
                    authService.logout();
                }else{
                    return request;
                }
            });
    
        }else{
            return request;
        } 
    }
   
    return request;
});